export default __webpack_public_path__ + "static/media/fb_ico.807740ae.svg";